// VER-218: 6-digit OTP entry for the Console. Thin wrapper over antd's Input.OTP
// (auto-advance, paste, backspace handled by antd), restricted to digits and
// firing onComplete once all 6 are entered. Reused by login and step-up.
import { Input } from "antd";

export default function OtpInput({ value, onChange, onComplete, disabled }) {
  return (
    <Input.OTP
      length={6}
      value={value}
      disabled={disabled}
      inputMode="numeric"
      formatter={(str) => str.replace(/\D/g, "")} // digits only
      onChange={(v) => {
        onChange?.(v);
        if (v && v.length === 6) onComplete?.(v);
      }}
    />
  );
}
